/* eslint-disable no-unused-expressions, no-magic-numbers, curly */

/**
 *  Form class to handle submission
*/
class Form {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    constructor(element, options) {

        this._options = {
            ...Form.options,
            ...options,
            timeout: 300
        };

        this._state = {
            isModal: false,
            currentScrollY: 0,
            expandedElements: []
        };

        this._element = element;
        this._fetchForm = this._fetchForm.bind(this);
        this._init();

    }

    /**
     * Initiate the form
     *
     * @private
     */
    _init() {
        this._cacheSelectors();
        this._setState();
        this._addListeners();
    }

    /**
     * Cache selectors
     *
     * @private
     */
    _cacheSelectors() {
        this._elements = {
            submit: this._element.querySelector('input[type="submit"]'),
            modal: this._element.closest('.modal'),
            input: [...this._element.querySelectorAll('input[type="number"], input[type="text"]')],
            closeForm: null
        };
    }

    /**
     * Set the state in case of a modal
     *
     * @private
     */
    _setState() {
        // eslint-disable-next-line no-magic-numbers
        this._state.isModal = typeof this._elements.modal !== 'undefined' && this._elements.modal !== null;
        this._options.action = this._options.action ? this._options.action : this._element.getAttribute('action');
        this._elements.closeForm = this._state.isModal && this._elements.modal.querySelector('[data-close-modal]');

    }

    /**
     * Add listeners
     *
     * @private
     */
    _addListeners() {
        document.addEventListener('keypress', event => {
            if (event.key === 'Enter') {
                const isInfocus = event.target.closest('fieldset');
                isInfocus && event.preventDefault();
                isInfocus && this._handleSubmit();
            }
        });

        this._elements.submit.addEventListener('click', event => {
            event.preventDefault();
            this._handleSubmit();
        });
    }

    /**
     * Submit the form or refresh the session
     *
     * @private
     */
    _handleSubmit() {
        const isDefault = !this._state.isModal;
        isDefault && this._element.submit();
        !isDefault && this._handleSessionRefresh();
    }

    /**
     * Refresh the session and store the current scroll position
     *
     * @private
     */
    _handleSessionRefresh() {
        this._state.currentScrollY = Math.abs(parseInt(document.body.style.top, 10));
        this._state.expandedElements = document.querySelectorAll('[data-is-open="true"]');

        if (typeof Storage === 'undefined') {
            this._fetchForm();
        } else {
            window.localStorage.setItem('scrollY', JSON.stringify(this._state.currentScrollY));
            const expandedArr = [];
            for (const element of this._state.expandedElements) {
                const elementId = element.getAttribute('id');
                if (elementId && elementId.includes('straks')) expandedArr.push(elementId);
            }
            window.sessionStorage.setItem('expandedElements', JSON.stringify(expandedArr));
            this._fetchForm();
        }
    }

    /**
     * Refresh the session and store the current scroll position
     *
     * @private
     */
    _fetchForm() {
        const body = {};
        this._elements.input.forEach(input => {
            const type = input.getAttribute('type');
            body[input.name] = type === 'number' ? parseInt(input.value, 10) : input.value;
        });

        const headers = { headers: { 'Accept': 'application/json, text/plain, */*', 'Content-Type': 'application/json' }, method: 'POST', body: JSON.stringify(body) };

        fetch(this._options.action, headers)
            .then(response => response.json())
            .then(json => {
                const isSuccess = json.status === 200;
                if (!isSuccess) {
                    this._handleFormError();
                }
                this._elements.closeForm && this._elements.closeForm.click();
                const timeout = setTimeout(() => {
                    location.reload();
                    clearTimeout(timeout);
                }, this._options.timeout);
            })
            .catch(() => {
                this._handleFormError();
            });
    }

    // eslint-disable-next-line class-methods-use-this
    _handleFormError() {
        // eslint-disable-next-line no-warning-comments
        // Todo : set notification
    }

}

export default Form;

/* eslint-enable */
